import { useTheme } from "../../../context/theme";
import { ContentEmphasis, KeyColorRole, Role } from "../types";

export function useContentColor({
  tone,
  emphasis,
  onHighEmphasisSurface
}: {
  tone: KeyColorRole;
  emphasis: ContentEmphasis;
  onHighEmphasisSurface: boolean;
}) {
  const theme = useTheme();

  let role: Role;

  if (onHighEmphasisSurface) {
    role = `contentOn-${tone}-high-surface`;
  } else {
    role = `${tone}-${emphasis}-content`;
  }

  return theme[role];
}
